import { FeatureFlagName, useIsFeatureOn } from "@/queries/feature-flag-query";
import { isGeRoutedFor } from "@/libs/global-e/marker";
import { useLocale } from "@/store/locale-store";

/**
 * **이 카트가 GE 국제 체크아웃으로 가는가** — 라우팅·배송비 표시·쿠폰 숨김의 단일 출처(카트 경로).
 *
 * 술어 자체는 [isGeRoutedFor] 에 있다 — 바로구매(`runCheckout`)는 non-hook 이라 이 훅을 못 쓰고
 * **같은 함수를 직접 호출**한다. 여기서 인라인으로 복제하면 두 경로가 갈린다(그 함수 주석에
 * #5233·#5296 실제 사례). 이 훅은 **flag·country 를 읽어 넘기는 얇은 껍데기**다.
 *
 * ## 배송비 표시가 여기 묶이는 이유
 *
 * GE 로 가면 배송비를 **GE 가 destination 기준으로 산정**한다(우리는 cart-info 로 배송비를 안 보낸다)
 * → 카트에서 우리 배송비 라인을 숨기고 Total 을 제품가-only 로 둔다. 요약박스(`PriceSummary`)와
 * 스티키 푸터(`filled-content`)가 **같은 값**을 써야 두 Total 이 어긋나지 않는다
 * (과거: 푸터만 배송비 포함으로 divergence).
 *
 * ⚠️ **US 도 GE 다**(2026-07-13). Fixed price(`usPrice` = 세금·관세·수수료 포함)로 보내고 배송비는
 * GE 가 어드민 설정으로 청구한다(이행은 비햅틱스 텍사스 3PL). 단 US 는 세금이 이미 가격에 포함돼
 * GE 가 **배송비만** 추가하므로, 표시 문구가 비-US("Shipping & taxes …")와 달라야 한다
 * — `price-summary-ui.tsx` 의 US 분기 참조.
 */
export function useGeRouted(): boolean {
  const geEnabled = useIsFeatureOn(FeatureFlagName.GlobalEEnabled);
  const { countryCode } = useLocale();
  return isGeRoutedFor(geEnabled, countryCode);
}
